
			// Load chatbot script
			var chatbotScript = document.createElement('script');
			chatbotScript.src = __KANBU_WEB_INPUT_CONFIG__.chatbotScriptUrl;
			chatbotScript.type = 'module';
			chatbotScript.async = true;
			document.body.append(chatbotScript);

			// Create web component
			var chatbotElement = document.createElement('kanbu-chatbot');
			chatbotElement.setAttribute('chat', __KANBU_WEB_INPUT_CONFIG__.defaultChabotId);
			document.body.append(chatbotElement);
		